/*
 * Copyright (c) 2023 Powerledger Pty Ltd. All Rights Reserved.
 */

import { MutationFunction } from "@apollo/client";
import { Dispatch, SetStateAction } from "react";

import {
  AccountLinkedRegistriesQuery,
  AccountType,
  LinkedRegistry,
  LinkRegistryMutation,
  LinkRegistryMutationVariables,
  RegistriesQuery,
  Registry,
  RegistryCode,
} from "@/app/types/generated/graphql";

import { RegistryModalCustomProps } from "./linked-registry-block/linked-registry-block.types";

export type LinkedRegistriesProps = {
  showModal?: boolean;
  openForm?: boolean;
  setOpenForm?: (e: boolean) => void;
  setSelectedRegistry?: (e: any) => void;
  selectedRegistry?: any;
};
export type UseLinkedRegistries = {
  refetchRegistries: () => Promise<void>;
  canLinkRegistry: boolean;
  loading: boolean;
  linkedRegistries: LinkedRegistry[];
  showRegistryModal: (args: RegistryModalCustomProps) => void;
  linkedRegistryText: string;
};
export type LinkedRegistriesViewProps = UseLinkedRegistries & LinkedRegistriesProps;

export const TraceXRegistriesList = {
  MRETS: "MRETS",
  ERCOT: "ERCOT",
} as const;

export type RegistryFormProps = {
  singlePage?: boolean;
  showModal?: boolean;
  closeModal: () => void;
  setSelectedRegistry?: (e: any) => void;
  selectedRegistry?: Registry | null;
  isRetryState?: boolean;
  retryRegistryInfo?: RegistryModalCustomProps["retryRegistryInfo"];
};

export type RegistryFormViewProps = RegistryFormProps & {
  showLegalDocumentModal: boolean;
  setShowLegalDocumentModal: Dispatch<SetStateAction<boolean>>;
  file: any;
  registryOptions: RegistriesQuery["registries"];
  linkedRegistriesData?: AccountLinkedRegistriesQuery;
  loading: boolean;
  loadingTranslatedFile: boolean;
  validateAccountNumber: (value: any, status: any, setStatus: any) => string | undefined;
  linkRegistry: MutationFunction<LinkRegistryMutation, LinkRegistryMutationVariables>;
};

export type RegistryFormValues = {
  registryId: string;
  registryCode: RegistryCode;
  type: AccountType;
  nrmTermsAccepted: boolean;
  accountNumber: string;
};
